import React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  className?: string;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, htmlFor, required = false, className = '', ...props }, ref) => {
    return (
      <label
        ref={ref}
        htmlFor={htmlFor}
        className={`block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 ${className}`}
        {...props}
      >
        {children}
        {required && <span className="ml-1 text-red-500" aria-label="Champ requis">*</span>}
      </label>
    );
  }
);

Label.displayName = 'Label';
